import { useServiceFactory } from '@euler/services/factory';
import { useCreation } from '@euler/utils/hooks/useCreation';
import { useCallback, useEffect, useState } from 'react';
import { BehaviorSubject } from 'rxjs';

const kKey = 'coaching.practice.speak';

/**
 * Whether the customer speaks aloud, remembered on this device; subtitles
 * show either way.
 */
export function useMutePreference() {
  const { defaultStorageService } = useServiceFactory();
  const speak$ = useCreation(() => new BehaviorSubject(true), []);
  // The scene opens once this is read: a muted trainee's opening line is
  // neither voiced nor billed.
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    defaultStorageService
      .get<boolean>(kKey)
      .then(value => {
        if (value === false) speak$.next(false);
      })
      .catch(error => console.error('coaching mute preference failed', error))
      .finally(() => setLoaded(true));
  }, [defaultStorageService, speak$]);
  const toggle = useCallback(() => {
    const next = !speak$.getValue();
    speak$.next(next);
    defaultStorageService
      .set(kKey, next)
      .catch(error => console.error('coaching mute preference failed', error));
  }, [defaultStorageService, speak$]);
  return { speak$, toggle, loaded };
}
